var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 31.25V30.0944C8.125 29.66 7.95937 29.2419 7.66187 28.9256C7.03187 28.2556 5.89562 27.0475 5.13812 26.2425C4.64812 25.7212 4.375 25.0325 4.375 24.3169C4.375 21.9944 4.375 16.6137 4.375 13.7487C4.375 12.7137 5.21375 11.875 6.24875 11.875H6.25125C6.74812 11.875 7.225 12.0725 7.57625 12.4238C7.9275 12.775 8.125 13.2519 8.125 13.7487C8.125 15.1681 8.125 16.875 8.125 16.875",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 31.25V30.0944C31.875 29.66 32.0406 29.2419 32.3381 28.9256C32.9681 28.2556 34.1044 27.0475 34.8619 26.2425C35.3519 25.7212 35.625 25.0325 35.625 24.3169C35.625 21.9944 35.625 16.6137 35.625 13.7487C35.625 12.7137 34.7862 11.875 33.7512 11.875H33.7488C33.2519 11.875 32.775 12.0725 32.4237 12.4238C32.0725 12.775 31.875 13.2519 31.875 13.7487C31.875 15.1681 31.875 16.875 31.875 16.875",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 35.2369V32.1537C18.125 31.9144 18.03 31.6844 17.86 31.515C17.6906 31.345 17.4606 31.25 17.2213 31.25C15.215 31.25 10.41 31.25 8.40375 31.25C8.16438 31.25 7.93437 31.345 7.765 31.515C7.595 31.6844 7.5 31.9144 7.5 32.1537C7.5 33.33 7.5 35.2369 7.5 35.2369",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 35.2369V32.1537C21.875 31.9144 21.97 31.6844 22.14 31.515C22.3094 31.345 22.5394 31.25 22.7787 31.25C24.785 31.25 29.59 31.25 31.5963 31.25C31.8356 31.25 32.0656 31.345 32.235 31.515C32.405 31.6844 32.5 31.9144 32.5 32.1537C32.5 33.33 32.5 35.2369 32.5 35.2369",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 31.25V27.8182C17.5 26.2938 16.875 24.8363 15.7706 23.785C14.3412 22.4244 12.3481 20.5275 11.0894 19.3288C10.4231 18.695 9.37375 18.7082 8.72375 19.3582L8.7225 19.3594C8.0475 20.0344 8.0475 21.1294 8.7225 21.8044C9.915 22.9975 11.5519 24.6338 11.5519 24.6338",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.25V27.8182C22.5 26.2938 23.125 24.8363 24.2294 23.785C25.6587 22.4244 27.6519 20.5275 28.9106 19.3288C29.5769 18.695 30.6262 18.7082 31.2762 19.3582L31.2775 19.3594C31.9525 20.0344 31.9525 21.1294 31.2775 21.8044C30.085 22.9975 28.4481 24.6338 28.4481 24.6338",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7756 10.8869L20 17.1875L14.2244 10.8869C12.92 9.46437 13.0162 7.24999 14.4394 5.94562C15.8625 4.64124 18.0769 4.73749 19.3812 6.16062L20 6.83562L20.6187 6.16062C21.9231 4.73749 24.1375 4.64124 25.5606 5.94562C26.9837 7.24999 27.08 9.46437 25.7756 10.8869Z",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 7.06812C24.9069 7.84249 24.9637 9.15562 24.19 9.99999",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService7);
export default __webpack_public_path__ + "static/media/service7.34a52f574d9e790b1849f96c7a04d37c.svg";
export { ForwardRef as ReactComponent };